// extracted by mini-css-extract-plugin
export default {"BodyNormal":"body-normal_BodyNormal__rxFQJ"};